// extracted by mini-css-extract-plugin
export var label = "index-module--label--3555x";
export var dropoffContainer = "index-module--dropoffContainer--1_MnY";